import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { checkBalanceN2 } from "../../../store/actions";
import { CHECK_BALANCE_N2_EVENT } from "../../../constants";


const Container = styled.div`
    width: 100%;
    margin: 16px 0 11px 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
`;

const Title = styled.h2`
    font-size: 14px;
    font-weight: normal;
    font-family: Amx-Regular;
    line-height: 160%;
    color: #000000;
`;

const Balance = styled.div`
    font-size: 13px;
    font-weight: bold;
    font-family: Amx-Bold;
    line-height: 160%;
    color: #000000;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0px;
    flex: 1;
`;

const MaskDots = styled.div`
    display: flex;
    gap: 4px;
    margin-left: 3px;
    padding-bottom: 1px;
`;

const Dot = styled.div`
    width: 8px;
    height: 8px;
    background-color: #1E1E1E;
    border-radius: 50%;
`;

const ShowBalance = styled.button`
    background: none;
    border: none;
    color: ${props => props.color || "#232323"};
    cursor: pointer;
    font-size: 13px;
    font-weight: 700;
    font-family: Telceltype-Bold;
    line-height: 160%;
    padding: 0;
    margin-left: auto;
`;

class CheckBalance extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        isVisible: false,
        balanceFromHome: props.balanceFromHome
        };
        
        this.toggleVisibility = this.toggleVisibility.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.checkBalanceN2Balance &&
            prevProps.checkBalanceN2Balance !== this.props.checkBalanceN2Balance
        ) {
            this.setState({ isVisible: true });
        }
    }

    hasBalanceFromHome() {
        const { balanceFromHome } = this.props;
        if (
            balanceFromHome == null ||
            balanceFromHome.balance == null ||
            balanceFromHome.balanceExpiration == null ||
            balanceFromHome.balanceFetchedAt == null
        ) {
            return false;
        }

        const elapsedMs = Date.now() - balanceFromHome.balanceFetchedAt;
        const expirationMs = balanceFromHome.balanceExpiration * 1000;
        return elapsedMs < expirationMs;
    }

    toggleVisibility() {
        const { isVisible } = this.state;

        if (!isVisible) {
            if (this.hasBalanceFromHome()) {
                this.setState({ isVisible: true });
            } else {
                this.props.checkBalanceN2(CHECK_BALANCE_N2_EVENT);
            }
        } else {
            this.setState(prevState => ({
            isVisible: !prevState.isVisible
            }));
        }
    }

    render() {
        const { isVisible } = this.state;
        const { checkBalanceN2Balance, balanceFromHome } = this.props;
        const amount = this.hasBalanceFromHome()
            ? `${balanceFromHome.balance}`
            : checkBalanceN2Balance && checkBalanceN2Balance.balance
                ? `${checkBalanceN2Balance.balance}`
                : "$0.00";

        return (
            <Container>
                <Title>
                    Dinero disponible
                </Title>
                <Balance>
                    $ 
                    {isVisible ? (
                        <span className="text-amount">{amount}</span>
                    ) : (
                        <MaskDots>
                            <Dot />
                            <Dot />
                            <Dot />
                        </MaskDots>
                    )}
                    <ShowBalance 
                        onClick={this.toggleVisibility}
                        color={this.props.isContainerTelcel ? "#0072E4" : "#232323"}
                    >
                        {isVisible ? "Ocultar" : "Mostrar"}
                    </ShowBalance>
                </Balance>
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    checkBalanceN2Balance: state.payments.checkBalanceN2Balance,
    balanceFromHome: state.payments.balanceFromHome
});

const mapDispatchToProps = (dispatch) => ({
    checkBalanceN2: (requestId) => dispatch(checkBalanceN2(requestId))
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckBalance);